<template>
    <div
        class="menu-card mb-3"
        @click="$emit('click')"
    >
        <div class="menu-left">
            <i
                v-if="iconClass"
                :class="iconClass"
            ></i>

            <slot name="icon"></slot>
        </div>

        <div class="menu-label">
            <span>{{ label }}</span>
        </div>

        <div class="menu-right">
            <i class="fas fa-angle-right"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: "SettingMenu",
    props: {
        label: {
            type: String,
            required: true
        },
        iconClass: {
            type: String,
            default: "fas fa-user"
        }
    }
};
</script>

<style scoped>
.menu-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-radius: 8px;
    background-color: #fff;
    cursor: pointer;
    transition: background 0.2s;
    box-shadow: 0 2px 10px 3px #e6e6e6;
}

.menu-card:hover {
    background: #f7f7f7;
}

.menu-left {
    width: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.menu-label {
    flex: 1;
    margin-left: 8px;
    font-size: 14px;
    font-weight: 500;
}

.menu-right {
    color: #888;
}
</style>
